import Company from '@/components/company/company';

export default {
  name: 'bind-env',
  props: {
    envAccount_dv: {
      type: Boolean,
      default: false,
    },
    isMasterBind: {
      type: Boolean,
      default: false,
    },
    isTestBind: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Company,
  },
  data() {
    return {
      envAccount_dialog: this.envAccount_dv,
      userLoginInfo: this.$store.getters.userLoginInfo,
      uniqueid: this.$store.getters.userLoginInfo.uniqueid,
      currentClientId: this.$store.getters.currentClientId,
      clientid: '', // 输入的
      APPsecret: '', // 输入的
      noMasterEnv: null, // 是否有正式环境开发者账号clientid
      company_dv: false,
      companyForm: {},
      titleType: 'new',
    };
  },
  watch: {
    envAccount_dv(val) {
      this.envAccount_dialog = val;
    },
  },
  methods: {
    async submitEnvAccount(type) {
      // console.log(type)
      // type->操作类别 1生产环境2集成环境
      if (!this.clientid || !this.APPsecret) {
        this.$API.ErrBase('clientid或APPsecret不能为空');
        return;
      }
      const params = {
        clientId: this.clientid,
        secret: this.APPsecret,
      };
      let apiName = '';
      if (type === 1) {
        apiName = 'bindAccountToFirm';
      } else {
        apiName = 'bindAccountToFirm_test';
        await this.$store.dispatch('loginStore/synLogin');
      }
      this.$API[apiName](params)
        .then((result) => {
          if (!this.$API.ApiRequest(result)) {
            return;
          }
          if (result.data) {
            const accountParam = {
              clientId: this.clientid,
              envType: type,
              checkCode: result.data,
            };
            this.$API
              .bindFirmToAccount(accountParam)
              .then((res) => {
                if (!this.$API.ApiRequest(res)) {
                  return;
                }
                // 集成环境绑定成功
                // 把集成环境testClientId存起来
                if (type === 1) {
                  // 1生产环境
                  this.userLoginInfo.clientId = this.clientid;
                  this.userLoginInfo.APPsecret = this.APPsecret;
                  this.$store.dispatch('loginStore/changeSetting', {
                    key: 'userLoginInfo',
                    value: this.userLoginInfo,
                  });
                  this.$store.dispatch('loginStore/defaultEnv', 'master');
                } else {
                  // 2、集成环境
                  this.userLoginInfo.testClientId = this.clientid;
                  this.userLoginInfo.testAPPsecret = this.APPsecret;
                  this.$store.dispatch('loginStore/changeSetting', {
                    key: 'userLoginInfo',
                    value: this.userLoginInfo,
                  });
                  // this.$store.dispatch('loginStore/defaultEnv', 'test');
                }
                this.$API.SuccessBase('绑定成功');
                this.envAccount_dialog = false;
                this.$emit('cancelDialog', this.envAccount_dialog);
              })
              .catch();
          }
        })
        .catch();
    },
    // 关闭绑定弹框
    cancelDialog() {
      this.envAccount_dialog = false;
      this.clientid = '';
      this.APPsecret = '';
      this.noMasterEnv = null;
      this.$emit('cancelDialog', this.envAccount_dialog);
    },
    // 用集成环境数据申请线上环境
    applyMasterClient() {
      this.$API
        .checkIntegration({ clientId: this.currentClientId })
        .then((result) => {
          if (!this.$API.ApiRequest(result)) {
            return;
          }
          if (result.data) {
            const tmpBaseInfo = this.$store.getters.baseInfo;
            this.companyForm = {
              firmName: tmpBaseInfo.firmName ? tmpBaseInfo.firmName : '', // 厂商名称
              firmPhone: tmpBaseInfo.firmPhone ? tmpBaseInfo.firmPhone : '', // 厂商联系手机号
              firmPerson: tmpBaseInfo.ontactsName ? tmpBaseInfo.ontactsName : '', // 厂商联系人
              channelApp: tmpBaseInfo.channelApp, // 产品形态APP
              channelSdk: tmpBaseInfo.channelSdk, // 产品形态SDK
              firmEmail: this.$store.getters.username,
            };
            this.company_dv = true;
          } else {
            this.$API.ErrBase('您尚未在集成环境完成用户签名的对接集成操作！');
          }
        })
        .catch();
    },
    cancelCompanyDialog() {
      this.company_dv = false;
      this.cancelDialog();
    },
  },
};
